import { Card, CardBody, Col } from "reactstrap";
import { UL } from "../../../../../../AbstractElements";
import CheckedFlatSwitch from "./CheckedFlatSwitch";
import SkewedFlipSwitch from "./SkewedFlipSwitch";
import CommonCardHeader from "../../../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { VariationOfSwitchesTitle } from "../../../../../../Constants/Constants";
import { VariationOfSwitchSubTitle } from "../../../../../../Data/Forms&Table/Forms/FormWidgets";

const VariationOfSwitches = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={VariationOfSwitchesTitle} span={VariationOfSwitchSubTitle} />
        <CardBody className="switch-wrapper">
          <UL className="tg-list common-flex simple-list flex-row">
            <SkewedFlipSwitch />
            <CheckedFlatSwitch />
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default VariationOfSwitches;
